import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretSolidDownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.013 22.043a1.6 1.6 0 0 0 2.141-.109l6.4-6.4a1.595 1.595 0 0 0-1.13-2.734h-12.8a1.6 1.6 0 0 0-1.48.989 1.573 1.573 0 0 0 .349 1.741l6.4 6.4z" })
});
export default SvgCaretSolidDownIcon;
